import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconLikeOn$1 = /*@__PURE__*/ proxyCustomElement(class WppIconLikeOn extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-like-on", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M1.54163 7.49984C1.54163 4.89937 3.6495 2.7915 6.24996 2.7915C7.735 2.7915 8.97502 3.50454 9.99996 4.75647C11.0249 3.50454 12.2649 2.7915 13.75 2.7915C16.3504 2.7915 18.4583 4.89937 18.4583 7.49984C18.4583 8.38019 18.0902 9.25213 17.5784 10.0668C17.0613 10.8899 16.3518 11.7258 15.5693 12.5481C14.7845 13.3728 13.9043 14.2064 13.0354 15.02C12.9136 15.1339 12.7922 15.2475 12.6712 15.3605C11.923 16.06 11.1932 16.7422 10.5303 17.4052C10.2374 17.6981 9.76252 17.6981 9.46963 17.4052C8.80668 16.7422 8.07691 16.06 7.32867 15.3605C7.20771 15.2475 7.08628 15.1339 6.96456 15.02C6.09564 14.2064 5.21539 13.3728 4.43061 12.5481C3.64812 11.7258 2.93864 10.8899 2.42152 10.0668C1.90976 9.25213 1.54163 8.38019 1.54163 7.49984Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-like-on-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-like-on", "wpp-icon-like-on-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-like-on-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-like-on-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconLikeOn$1);
      }
      break;
  } });
}

const WppIconLikeOn = WppIconLikeOn$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconLikeOn, defineCustomElement };
